const depoimentos = [
  {
    nome: 'Ana Carolina M.',
    bairro: 'Moema',
    texto: 'Instalação impecável. O sistema sem roldana é outro nível — não faz barulho nenhum e ficou lindo. Superou minhas expectativas.',
  },
  {
    nome: 'Roberto C.',
    bairro: 'Itaim Bibi',
    texto: 'Fizeram a aprovação no condomínio, entregaram no prazo e o acabamento ficou perfeito. Recomendo de olhos fechados.',
  },
];

export default function ProvaSocial() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Texto de posicionamento */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 bg-stone-100 border border-stone-200 rounded-full px-6 py-3 mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-star-line text-amber-600 text-lg"></i>
            </div>
            <p className="text-stone-800 font-semibold text-sm">
              Nosso orçamento não é o mais barato, é o justo.
            </p>
          </div>
        </div>

        {/* Depoimentos em destaque */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
          {depoimentos.map((dep) => (
            <div key={dep.nome} className="bg-stone-50 rounded-xl p-6 border border-stone-100">
              <div className="flex gap-0.5 mb-3 text-amber-400 text-sm">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill"></i>
                  </div>
                ))}
              </div>
              <p className="text-stone-600 text-sm leading-relaxed mb-4 italic">
                &ldquo;{dep.texto}&rdquo;
              </p>
              <div>
                <p className="font-semibold text-stone-800 text-xs">{dep.nome}</p>
                <p className="text-stone-400 text-xs">{dep.bairro}, São Paulo</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}